import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DbImportGlyph = /*#__PURE__*/createElement("g", {
  id: "db-import-icon"
}, /*#__PURE__*/createElement("path", {
  d: "M48.36 55.07l-5.22-5.22c-.21-.21-.47-.32-.73-.38-.08-.02-.16-.04-.24-.05-.04 0-.08-.01-.12-.01-.02 0-.04-.01-.05-.01-.56 0-1.04.31-1.3.76l-5.08 5.08a1.49 1.49 0 000 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l2.75-2.75v13.56c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V54.45l2.74 2.74c.59.59 1.54.59 2.12 0s.6-1.54.01-2.12z"
}), /*#__PURE__*/createElement("path", {
  d: "M65.49 22.75c-.28-5.52-11.95-8.42-23.49-8.42s-23.21 2.89-23.49 8.42h-.01v29.49c0 2.91 3.13 5.11 7.76 6.55.94.29 1.9-.43 1.9-1.42v-.04c0-.65-.42-1.22-1.03-1.41-3.61-1.12-5.64-2.53-5.64-3.69V37.15c4.25 2.76 12.41 4.18 20.5 4.18s16.25-1.42 20.5-4.18v15.09c0 1.15-2.03 2.57-5.64 3.69-.61.19-1.03.76-1.03 1.41v.04c0 .99.96 1.71 1.9 1.42 4.63-1.45 7.76-3.64 7.76-6.55v-29.5h.01zm-2.99 9.96c0 2.29-7.99 5.62-20.5 5.62S21.5 35 21.5 32.71v-5.32c4.25 2.76 12.41 4.18 20.5 4.18s16.25-1.42 20.5-4.18v5.32zM42 28.57c-12.51 0-20.5-3.33-20.5-5.62s7.99-5.62 20.5-5.62 20.5 3.33 20.5 5.62-7.99 5.62-20.5 5.62z"
}));
const DbImport = createSvg({
  name: 'db-import',
  path: DbImportGlyph
});

export default DbImport;
export { DbImportGlyph };
